module.exports = __webpack_public_path__ + "img/m-funding-structure.03bdd13e.jpg";